import { IChecklistItem } from '../../../../store/reducers/admin/assistant';
import Icon, { COLORS, ICONS } from '../../../general-ui/icon';
import { useTypedSelector } from "../../../../store/reducers/use-typed-selector";
import './checklist-item.scss';
import { useMemo } from 'react';

interface ChecklistItemProps {
	option: IChecklistItem;
}

const ChecklistItem: React.FC<ChecklistItemProps> = (props) => {
	const {
		AuthReducer: {
			user,
			onboardedLoading
		}
	} = useTypedSelector(state => state);
	
	const { option } = props;

	const check = useMemo(() => {
		// return JSX element for checkmark in list depending on whether the task has been completed
		return (
			<div className="option-check">
				{user?.onboarded.includes(option.title) ?
					<div className="checked">
					<Icon 
						name={ICONS.CHECK} 
						size={14} 
						color={COLORS.BLACK} 
					/>
					</div> :
					<div className="unchecked"></div>
				}
			</div>
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.onboarded, option.title, onboardedLoading]);

	return (
		<div key={option.title} className={`progress-option`}>
			<button className="no-style" style={{ margin: 0 }}>
				{check}
				<div className={`option-text ${user?.onboarded.includes(option.title) ? 'completed' : ''}`}>
					<div className="option-text-title">{option.title}</div>
					<div className="option-text-description">{option.description}</div>
				</div>
			</button>
		</div>
	);
};

export default ChecklistItem;